import { FC } from 'react';
import { FormState, UseFormRegister } from 'react-hook-form';

import {
  useContractListStore,
  useContractEditStore,
} from 'page/CustomerPage/hooks';
import { ContractFormFields } from 'page/CustomerPage/types/contractFormField';
import { InputModalView } from 'page/CustomerPage/components/ContractEditModal/InputModalView';

type Props = {
  formState: FormState<ContractFormFields>;
  register: UseFormRegister<ContractFormFields>;
  handleClose: () => void;
  handleClickGoConfirmation: () => void;
  handleClickGoDelete: () => void;
};

export const InputModal: FC<Props> = ({
  formState,
  register,
  handleClose,
  handleClickGoConfirmation,
  handleClickGoDelete,
}) => {
  const {
    isOpenInputModal,
    startDate,
    endDate,
    changeStartDate,
    changeEndDate,
  } = useContractEditStore();
  const { selectedContract } = useContractListStore();
  const { uncontractedMenusAddedCurrentMenu } = useContractListStore();

  /** 確認ボタンの非活性状態 */
  const isButtonDisabled = !formState.isValid || !startDate || !endDate;

  return (
    <>
      {/* 入力モーダル */}
      <InputModalView
        formState={formState}
        isOpen={isOpenInputModal}
        isButtonDisabled={isButtonDisabled}
        contractId={selectedContract?.id}
        startDate={startDate}
        endDate={endDate}
        uncontractedMenusAddedCurrentMenu={uncontractedMenusAddedCurrentMenu}
        register={register}
        changeStartDate={changeStartDate}
        changeEndDate={changeEndDate}
        handleClose={handleClose}
        handleClickGoConfirmation={handleClickGoConfirmation}
        handleClickGoDelete={handleClickGoDelete}
      />
    </>
  );
};
